import { Component, OnInit } from '@angular/core';
import { AstrolyticsService } from "../../_services/astrolytics.service";
import { Subscription } from 'rxjs'
import { environment } from "../../../environments/environment";
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { AuthenticationService } from '../../_services/authentication.service';
import { CacheService } from '../../_services/cache.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-explore-page',
  templateUrl: './explore-page.component.html',
  styleUrls: ['./explore-page.component.css']
})
export class ExplorePageComponent implements OnInit {


  categorySubscription: Subscription;
  leafCategorySubscription: Subscription;
  userFavoritesSubscription: Subscription;
  trendsSubscription: Subscription;

  root_categories;

  list_number;
  category_path;
  current_category;
  path_from_root;
  category_statistics;

  loading;
  showErrorMessage = false;

  graphResults;
  sellerGraphResults
  directMother;

  user_favorites;

  source;

  trends_clicked = false;
  trends_show = true;
  trends_current;
  trends_name;

  cacheKey;

  maxFavorites = environment.maxFavorites;

  chunkArray(myArray, chunk_size) {
    var index = 0;
    var arrayLength = myArray.length;
    var tempArray = [];

    for (index = 0; index < arrayLength; index += chunk_size) {
      var myChunk = myArray.slice(index, index + chunk_size);
      tempArray.push(myChunk);
    }

    return tempArray;
  }

  filterAndSortArray(ar) {
    var ret = [];

    for (let data in ar) {
      if (ar[data].percentage > 0) {
        ret.push(ar[data])
      }
    }


    ret.sort(function (a, b) {
      if (a.id == "0") {
        return 1;
      }

      if (b.id == "0") {
        return -1;
      }
      return b.percentage - a.percentage;

    });



    while (ret.length > 10) {
      var x = ret.pop();
      if (x.id == "0") {
        ret.unshift(x);
      }
    }


    return ret;
  }

  constructor(private cs: CacheService, private astrolyticsService: AstrolyticsService, private authenticationService: AuthenticationService, private route: ActivatedRoute,  private router: Router) {

    if (!authenticationService.isAuth()){
      this.router.navigate(['/login']);
    } else{
      this.cacheKey = "favorites-data-"+this.authenticationService.currentUserValue.id;
      this.source = this.route.snapshot.queryParamMap.get("source");

      this.loading = false;
      this.path_from_root = undefined;
      this.current_category = undefined;
      this.category_statistics = undefined;
      this.user_favorites = undefined;

      registerLocaleData(localeFr, 'fr');
      this.categorySubscription = this.astrolyticsService.categoriesObservable.subscribe(message => {

        if (message){
          if (this.user_favorites == undefined){
            astrolyticsService.getUserFavorites(this.authenticationService.currentUserValue.id)
          }
        }

        this.loading = false;
        this.showErrorMessage = false;
        if (message.children_categories) {
          this.category_statistics = undefined;
          this.current_category = message;
          this.path_from_root = message.path_from_root;
          this.directMother = message.path_from_root[message.path_from_root.length - 2];
          if (message.children_categories.length == 0) {
            this.loading = true;
            this.astrolyticsService.getCategoryStatistics(this.current_category.id);
          } else {
            var split = this.chunkArray(message.children_categories, message.children_categories.length / 2);
          }
          this.trends_show = false;

        } else {
          this.path_from_root = undefined;
          this.current_category = undefined;
          this.trends_show = true;
          var split = this.chunkArray(message, message.length / 2);
        }
        if (split && split[0] && split[1] && split[0].length < split[1].length) {
          split[0].push(split[1].shift());
        }
        this.root_categories = split;

      });

      this.leafCategorySubscription = this.astrolyticsService.leafCategoriesObservable.subscribe(message => {

        this.showErrorMessage = false;
        if (this.loading) {
          if (message && message.top_listings) {
            this.loading = false;
            message.top_listings.sort(function (a, b) {
              if (a.quantity_sold != b.quantity_sold) {
                return b.quantity_sold - a.quantity_sold;
              }
              return b.price - a.price;

            });

            this.category_statistics = message;

            this.graphResults = this.filterAndSortArray(message.revenue_graph);
            this.sellerGraphResults = this.filterAndSortArray(message.seller_graph);

          }
          else {
            if (message == null) {
              this.loading = false;
              this.showErrorMessage = true;
            }
          }
        }
      });

      this.userFavoritesSubscription = this.astrolyticsService.userFavoritesObservable.subscribe(message => {
        if (message) {
          this.user_favorites = message
        }
      })

      this.trendsSubscription = this.astrolyticsService.trendsObservable.subscribe(message => {
        if (message) {
          message.trends = this.chunkArray(message.trends, message.trends.length / 2);
          this.trends_current = message;
        }
      });

      if (this.source) {
        astrolyticsService.getCategoryData(this.source);

      } else {
        astrolyticsService.getCategoryData("root");
      }
    }
  }

  ngOnInit() {
    this.path_from_root = undefined;
    this.current_category = undefined;
    this.category_statistics = undefined;
    this.user_favorites = undefined;
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.

  }

  ngOnDestroy() {
    this.categorySubscription.unsubscribe();
    this.leafCategorySubscription.unsubscribe();
    this.userFavoritesSubscription.unsubscribe();
    this.trendsSubscription.unsubscribe();

    this.path_from_root = undefined;
    this.current_category = undefined;
    this.category_statistics = undefined;
    this.user_favorites = undefined;
  }

  clickCategory(meli_id) {
    if (!this.trends_clicked) {
      this.current_category = undefined;
      this.category_statistics = undefined;
      this.astrolyticsService.getCategoryData(meli_id);
    }
    this.trends_clicked = false;

  }

  clickTrends(meli_id, name) {
    this.trends_current = undefined;
    this.trends_clicked = true;
    this.trends_name = name;
    this.astrolyticsService.getTrends(meli_id);
  }


  onFav(element_id, resource_type) {
    if (this.user_favorites[resource_type].includes(element_id)) {
      let index = this.user_favorites[resource_type].indexOf(element_id)
      this.user_favorites[resource_type].splice(index, 1)
      this.updateFavs()
      if (resource_type == "listings") {
        this.deleteFavData(element_id)
      }
    } else {
      if (this.user_favorites[resource_type].length < this.maxFavorites) {
        this.user_favorites[resource_type].push(element_id)
        this.updateFavs()
              if (resource_type == "listings") {
                this.createFavData(element_id)
              }
      } else {
        //Avisar que no se puede
        let alert: any = $('.alert')
        alert.show({ easing: "swing" })
        setTimeout(() => {
          alert.hide({ duration: 500 })
        }, 5000);
      }
    }
  }

  updateFavs() {
    var user_id = this.authenticationService.currentUserValue.id
    this.astrolyticsService.updateUserFavorites(this.user_favorites, user_id)
    this.cs.clearCache(this.cacheKey);
  }

  downloadExcel() {
    this.astrolyticsService.downloadExcel(this.category_statistics)
  }

  deleteFavData(meliId) {
    var userId = this.authenticationService.currentUserValue.id
    this.astrolyticsService.deleteUserFavData(userId, meliId)
    this.cs.clearCache(this.cacheKey);
  }

  createFavData(meliId) {
    var userId = this.authenticationService.currentUserValue.id
    this.astrolyticsService.createUserFavData(userId, meliId)
    this.cs.clearCache(this.cacheKey);
  }
}
